import { render, staticRenderFns } from "./ProjectDataTable.vue?vue&type=template&id=35816f6e&scoped=true"
import script from "./ProjectDataTable.vue?vue&type=script&lang=js"
export * from "./ProjectDataTable.vue?vue&type=script&lang=js"
import style0 from "./ProjectDataTable.vue?vue&type=style&index=0&id=35816f6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35816f6e",
  null
  
)

export default component.exports